export default __webpack_public_path__ + "static/media/Background.b98d21cd.png";